export interface ConsumerMarketConfidence {
  type: string; // The type of the element (e.g., 'mileage', 'color', etc.)
  value: number; // The value associated with the element
  titlePrice?: string; // The title of the price
  description: string; // A description of the element
  isPositiveValue: boolean; // Indicates if the value is positive
  displayValue?: string; // The value to display
  shouldDisplay: boolean; // Indicates if the element should be displayed
  hasIcon?: boolean; // Indicates if the element has an icon
}

export interface AdditionalInsight extends ConsumerMarketConfidence {
  disclaimers: string;
}

export const CONSUMER_MARKET_CONFIDENCE_DEFAULT: ConsumerMarketConfidence = {
  type: '',
  description: '',
  titlePrice: '',
  hasIcon: false,
  isPositiveValue: false,
  displayValue: '',
  shouldDisplay: false,
  value: 0,
};

export const ADDITIONAL_INSIGHTS_DEFAULT: AdditionalInsight = {
  ...CONSUMER_MARKET_CONFIDENCE_DEFAULT,
  disclaimers: '',
};

export interface HistoryIcon {
  icon: string;
  label: string;
}
